module.exports = __webpack_public_path__ + "static/media/full-house-sm.ca6d6177.png";